import { ROOT_URL } from "../../../routes/constants";
import Error401 from '../Errors/401';
import Error404 from '../Errors/404';
import VersionApp from '../Extra/VersionApp';
import FAQApp from '../Extra/FAQApp';
import UserRoutes from '../User/routes';
import ProductRoutes from '../Product/routes';
import ProductClassRoutes from '../ProductClass/routes';
import BusinessPartnerRoutes from '../BusinessPartner/routes';
import ProposalRoutes from '../Proposal/routes';
import BpOrderRoutes from '../BPOrder/routes';
import OrderPatternRoutes from '../OrderPattern/routes';
import ContactRoutes from '../Contact/routes';
import MobileContactRoutes from '../MobileContact/routes';
import MobileOrdersRoutes from '../MobileOrders/routes';

export const FAQ = ROOT_URL + "/faq";

const CommonRoutes = [{
        path: ROOT_URL+"/version",
        component: VersionApp,
        exact:true
    },{
        label: "FAQ",
        path: FAQ,
        component: FAQApp,
        exact:true
    },{
        path: ROOT_URL+"/401",
        component: Error401,
        exact:true
    },{
        component: Error404
    } 
]
const AdminRoutes = [
    /* Insert admin module routes here*/
    ...ContactRoutes    
    ,...BpOrderRoutes
    ,...ProposalRoutes
    ,...UserRoutes
    ,...ProductRoutes
    ,...ProductClassRoutes
    ,...OrderPatternRoutes
    ,...BusinessPartnerRoutes
    ,...CommonRoutes
];

const MobileRoutes = [
    /* Insert user module routes here*/
    ...MobileContactRoutes
    ,...MobileOrdersRoutes
    ,...CommonRoutes 
];

export default {AdminRoutes , MobileRoutes};